import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-tutorial-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tutorial-dialog.component.html',
  styleUrl: './tutorial-dialog.component.scss'
})
export class TutorialDialogComponent {
  @Input() position!: { top: string; left: string; };
  @Input() title!: string;
  @Input() description!: string;
  @Input() currentStep!: number;
  @Input() totalSteps!: number;

  @Output() continue = new EventEmitter<void>();
  @Output() skip = new EventEmitter<void>();
  @Output() reset = new EventEmitter<void>();

  onContinue() {
    this.continue.emit();
  }

  onSkip() {
    this.skip.emit();
  }

  onReset() {
    this.reset.emit();
  }

  getDialogPosition() {
    return {
      top: `${this.position.top}`,
      left: `${this.position.left}`
    };
  }
}
